// extracted by mini-css-extract-plugin
export var truncate = "_z-0";